import React from 'react';

import Card from '../Card.js';
import PropertyTable from './PropertyTable.js';
import TableToolBar from './TableToolbar.js';
import Header from './Header';
import Filters from './Filters';

import { Context as PropertyContext } from '../../context/property.context';
import { Context as AuthContext } from '../../context/auth.context';

const PropertySearch = (props) => {
	const { state } = React.useContext(PropertyContext);
	const auth = React.useContext(AuthContext);

	React.useEffect(() => {
		function handleScrollYChange() {
			const lastScrollY = window.scrollY;
			// console.log(lastScrollY);
			if (lastScrollY) {
				localStorage.setItem('scrollY', lastScrollY);
			}
		}
		window.addEventListener('scroll', handleScrollYChange, true);
		return () => {
			window.removeEventListener('scroll', handleScrollYChange);
		};
	}, []);

	return (
		<>
			<Header />
			<Card>
				<TableToolBar />

				{state.taxBills.length > 0 && (
					<div
						style={{
							width: '100%',
							display: 'flex',
							flexDirection: 'row',
							marginTop: 40,
						}}
					>
						{auth.state.merchant.visibleFilters.length > 0 && (
							<Filters />
						)}

						<PropertyTable />
					</div>
				)}
			</Card>
		</>
	);
};

export default PropertySearch;
